import formatPercent from "../../hooks/formatPercent";
import {
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Switch,
  TextField,
} from "@mui/material";

import axios from "axios";
import Cookies from "js-cookie";
import { FaChevronRight, FaCoins } from "react-icons/fa";
import { IoLocationOutline, IoTicketOutline } from "react-icons/io5";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";

import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import PurchaseHeader from "./purchaseComponents/PurchaseHeader";
import ModalPaymentOption from "./purchaseComponents/ModalPaymentOption";
import {
  fetchCheckoutCartNew,
  fetchCheckoutCartPbf,
  getCreditCardPlanPbf,
  getPaymentMethodNew,
  getPaymentMethodPbf,
  getShippingPbf,
  submitPurchaseCheckoutPbf,
} from "../../../services/purchaseApi";
import ModalVoucher from "./purchaseComponents/ModalVoucher";
import { SPECIAL_LABEL } from "../../constants/constant";
import CheckoutConfirm from "./CheckoutConfirm";
import ModalOverduePayment from "./purchaseComponents/ModalOverduePayment";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import { useNavigate } from "react-router-dom";

const token = () => Cookies.get("accessTokenOfficeOlin");

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const CheckoutPurchase = () => {
  const isTaxFree = localStorage.getItem("is_tax_free");
  const navigate = useNavigate();

  const [otpPage, setOtpPage] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);
  const [openVoucher, setOpenVoucher] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [usePoint, setUsePoint] = useState(false);
  const [shipping, setShipping] = useState(null);
  const [useInsurance, setUseInsurance] = useState(false);
  const [noteArr, setNoteArr] = useState([]);
  const [creditDetail, setCreditDetail] = useState(null);
  const [openModalOverdue, setOpenModalOverdue] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const getGrandTotal = () => {
    return dataCheckout
      ? dataCheckout.summary.grand_total_estimate +
          // (isTaxFree === "true"
          //   ? 0
          //   : Math.round(dataCheckout.summary.subtotal * 0.11)) +
          getShippingFee() +
          (paymentMethod && !(selectedPayment && selectedPayment === "008")
            ? hasPlan() &&
              dataPlan &&
              creditDetail &&
              typeof creditDetail !== "number"
              ? dataPlan[creditDetail.index].total_summary
                  .total_fee_after_ppn_int
              : selectedPayment === "0"
                ? 0
                : Number(paymentMethod.bank_fee)
            : 0) -
          ((usePoint ? dataCheckout.loyalty_point_balance : 0) +
            (selectedVoucher ? getVoucherValue() : 0))
      : 0;
  };

  const getSubtotal = () => {
    return dataCheckout
      ? dataCheckout.summary.subtotal +
          // (isTaxFree === "true"
          //   ? 0
          //   : Math.round(dataCheckout.summary.subtotal * 0.11)) +
          getShippingFee() -
          ((usePoint ? dataCheckout.loyalty_point_balance : 0) +
            (selectedVoucher ? getVoucherValue() : 0))
      : 0;
    // return dataCheckout ? dataCheckout.summary.subtotal : 0;
  };

  const getShippingFee = () => {
    // const shipFee = shippingMethod ? shippingMethod.rate : 0;
    // const insuranceFee =
    //   shippingMethodInsurance && useInsurance
    //     ? shippingMethodInsurance.rate
    //     : 0;

    // return shipFee + insuranceFee;
    return 0;
  };

  const getVoucherValue = () => {
    if (!selectedVoucher || !dataCheckout) return 0;
    else {
      const totalSum = dataCheckout.summary.subtotal;
      const fullVoucher = (selectedVoucher.discount_value / 100) * totalSum;

      return totalSum < selectedVoucher.min_purchase
        ? 0
        : fullVoucher > selectedVoucher.max_promo
          ? selectedVoucher.max_promo
          : fullVoucher;
    }
  };

  const getInstallmentString = () => {
    return creditDetail
      ? typeof creditDetail === "number"
        ? `Tempo ${creditDetail} hari`
        : creditDetail.installment_type === 0 &&
            creditDetail.installment_plan === "Direct"
          ? "Bayar Penuh"
          : `${creditDetail.installment_details.month} bulan`
      : "";
  };

  const hasPlan = () => {
    const returnVal =
      (selectedPayment !== null &&
        // Credit Cards
        selectedPayment === "902") ||
      selectedPayment === "008" ||
      // Paylater
      selectedPayment === "904" ||
      selectedPayment === "112" ||
      selectedPayment === "777";

    return returnVal;
  };

  const {
    mutate: mutateCheckout,
    data: dataCheckout,
    isLoading: isLoadingCheckout,
  } = useMutation({
    mutationFn: fetchCheckoutCartPbf,
  });

  const { mutate: mutateSubmitCheckout, isLoading: isLoadingSubmitCheckout } =
    useMutation({
      mutationFn: submitPurchaseCheckoutPbf,
      // onSuccess: () => setOtpPage(true),
      // all pages immediately redirect to billing (excluding cc, opens redirect cc url)
      onSuccess: (data) => {
        // CBD (card redirect, VA or account number): pay first; the result
        // page follows once the payment is confirmed.
        if (
          data.payment.is_redirect ||
          data.payment.va ||
          data.payment.account_no
        ) {
          navigate(`/purchase-pbf/confirm-checkout/${data.invoices[0].invoice_uid}`);
        } else {
          navigate(`/purchase-pbf/checkout-result/${data.checkout_group_uid}`);
        }
      },

      onError: (err) =>
        navigate(`/purchase-pbf/checkout-result/failed`, {
          state: { message: err.message?.id ? err.message.id : err.message },
        }),
    });

  const { data: dataPaymentMethod, isFetching: isFetchingPaymentMethod } =
    useQuery({
      queryKey: ["payment-method", openPayment],
      queryFn: () => getPaymentMethodPbf(),
      refetchOnWindowFocus: false,
    });

  const { data: dataShipping, isFetching: isFetchingShipping } = useQuery({
    queryKey: ["shipping-pbf"],
    queryFn: () => getShippingPbf(),
    refetchOnWindowFocus: false,
  });

  const shippingMethod = useMemo(() => {
    return dataShipping && shipping
      ? dataShipping.rates.find((item) => item.provider === shipping)
      : null;
  }, [shipping]);

  const shippingMethodInsurance = useMemo(() => {
    return shipping
      ? dataShipping.insurances.find((item) => item.provider === shipping)
      : null;
  }, [shipping]);

  const paymentMethod = useMemo(() => {
    var foundItem = null;
    if (selectedPayment && dataPaymentMethod) {
      const paymentOption = {
        // Blok tempo sekarang bisa null: apotek yang tidak diberi limit
        // tidak menerimanya sama sekali. Menyebarkan null akan menyisakan
        // baris opsi kosong yang tetap bisa dipilih.
        ...(dataPaymentMethod.tempo
          ? { tempo: [{ ...dataPaymentMethod.tempo, code: "0" }] }
          : {}),
        ...dataPaymentMethod.cbd,
      };

      Object.keys(paymentOption)?.map((key) => {
        paymentOption[key]?.map((payment) => {
          if (payment.code === selectedPayment) foundItem = payment;
        });
      });
    }

    return foundItem;
  }, [selectedPayment, dataPaymentMethod]);

  const handleSelectShipping = (ship) => {
    if (!dataShipping) return;
    const insurance = dataShipping.insurances.find(
      (item) => item.provider === ship,
    );
    setUseInsurance(dataShipping && insurance ? insurance : false);
    setShipping(ship);
  };

  const { data: dataPlan, isFetching: isFetchingPlan } = useQuery({
    queryKey: ["plan-credit", selectedPayment],
    queryFn: () =>
      getCreditCardPlanPbf({
        payment_channel_id: paymentMethod.id ? paymentMethod.id : 0,
        grand_total: getSubtotal(),
      }),
    enabled: hasPlan() && paymentMethod !== undefined,
  });

  useEffect(() => {
    if (dataCheckout) {
      setNoteArr([...Array(dataCheckout.items.length).fill("")]);
    }
  }, [dataCheckout]);

  useEffect(() => {
    mutateCheckout();
  }, []);

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <LoadingBackdrop isLoading={isLoadingSubmitCheckout} />
      {otpPage ? (
        <CheckoutConfirm
          dataPreview={{
            dataCheckout: dataCheckout,
            payment: paymentMethod,
            voucher: selectedVoucher,
            usePoint: usePoint,
            voucherValue: getVoucherValue(),
            grandTotal: getGrandTotal(),
            shipping: [], //shippingArr,
            noteArr: noteArr,
            creditDetail: creditDetail,
          }}
        />
      ) : (
        <>
          <PurchaseHeader />
          <div className="mt-[70px]">
            <div className="px-3 pt-2 mb-4">
              <BreadcrumbPurchase />
            </div>
            <div className="px-3 mb-4">
              <p className="text-[24px] font-semibold">Checkout</p>
            </div>

            <div className="px-3 mb-4 flex flex-col lg:flex-row gap-4">
              <div className="w-full">
                <div className="w-full bg-white rounded-lg p-4 h-fit mb-4">
                  <p className="text-[20px] mb-2 font-bold">
                    Alamat Pengiriman
                  </p>
                  <div className="flex gap-3">
                    <IoLocationOutline className="text-[20px] text-green-500" />
                    {dataCheckout && !isLoadingCheckout ? (
                      <div className="w-full">
                        <p className="font-bold">
                          {dataCheckout.address.company_name} -{" "}
                          {dataCheckout.address.phone}
                        </p>
                        <p>
                          {dataCheckout.address.address},{" "}
                          {dataCheckout.address.subdistrict},{" "}
                          {dataCheckout.address.district},{" "}
                          {dataCheckout.address.city},{" "}
                          {dataCheckout.address.province}{" "}
                          {dataCheckout.address.postal_code}
                        </p>
                      </div>
                    ) : isLoadingCheckout ? (
                      <CircularProgress size={20} />
                    ) : (
                      <p className="text-red-500">
                        Terjadi kesalahan dalam mengambil data checkout
                      </p>
                    )}
                  </div>
                </div>

                {dataCheckout && !isLoadingCheckout && dataCheckout.items ? (
                  // map the pbfs, currently only has one
                  [1].map((item, i) => {
                    return (
                      <div className="w-full bg-white rounded-lg p-4 h-fit mb-4">
                        <div className="flex justify-between text-[16px]">
                          {/* <p>{item.name}</p> */}
                          <p></p>
                          <p>Subtotal</p>
                        </div>

                        {dataCheckout.items.filter(
                          (product) =>
                            !SPECIAL_LABEL.map(
                              (label) => label.label_name,
                            ).includes(product.label),
                        ).length > 0 ? (
                          <>
                            <hr className="my-3" />
                            <p className="text-[16px] mb-4">General</p>
                          </>
                        ) : null}
                        {dataCheckout.items
                          .filter(
                            (product) =>
                              !SPECIAL_LABEL.map(
                                (label) => label.label_name,
                              ).includes(product.label),
                          )
                          .map((product, i) => {
                            return (
                              <div>
                                <div>
                                  <div
                                    className={`flex items-stretch gap-4 ${
                                      i === 0 ? "" : "mt-4"
                                    }`}
                                  >
                                    <img
                                      src={product.image ? product.image : ""}
                                      className="w-[100px] h-[100px] object-contain rounded-md border-2"
                                    />
                                    <div className="w-full">
                                      <p className="bg-[#EBF5FE] text-[#3194F6] py-1 px-3 mb-2 rounded-full w-fit">
                                        {product.label}
                                      </p>
                                      <p className="text-[16px] font-semibold">
                                        {product.name}
                                      </p>
                                      <div className="hidden md:flex gap-2 items-center">
                                        {product.discount ? (
                                          <p>
                                            <s>{toIDR(product.unit_price)}</s>
                                          </p>
                                        ) : null}
                                        {product.discount ? (
                                          <p className="bg-red-100 text-red-500 p-1 rounded-lg">
                                            {formatPercent(product.discount.percent)}
                                          </p>
                                        ) : null}
                                        <p>
                                          {toIDR(
                                            product.discount
                                              ? (product.unit_price *
                                                  (100 -
                                                    product.discount.percent)) /
                                                  100
                                              : product.unit_price,
                                          )}{" "}
                                          x {product.qty}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="hidden md:flex items-end justify-end">
                                      <p className="mb-2 text-right">
                                        {toIDR(
                                          product.qty *
                                            (product.discount
                                              ? (product.unit_price *
                                                  (100 -
                                                    product.discount.percent)) /
                                                100
                                              : product.unit_price),
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mt-2 md:mt-0 md:hidden flex items-end justify-between">
                                    <div>
                                      <div className="flex gap-2 items-center">
                                        {product.discount ? (
                                          <p>
                                            <s>{toIDR(product.unit_price)}</s>
                                          </p>
                                        ) : null}
                                        {product.discount ? (
                                          <p className="bg-red-100 text-red-500 p-1 rounded-lg">
                                            {formatPercent(product.discount.percent)}
                                          </p>
                                        ) : null}
                                      </div>
                                      <p className="font-semibold">
                                        {toIDR(
                                          product.discount
                                            ? (product.unit_price *
                                                (100 -
                                                  product.discount.percent)) /
                                                100
                                            : product.unit_price,
                                        )}{" "}
                                        x {product.qty}
                                      </p>
                                    </div>
                                    <div className="text-right font-semibold">
                                      {toIDR(
                                        product.qty *
                                          (product.discount
                                            ? (product.unit_price *
                                                (100 -
                                                  product.discount.percent)) /
                                              100
                                            : product.unit_price),
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* {product.bonus_info &&
                                product.bonus_info.bonus_name !== "" &&
                                product.bonus_info.bonus_qty > 0 ? (
                                  <div className="my-4 pl-20 md:pl-28 flex w-full gap-4 items-center overflow-hidden truncate">
                                    <img
                                      src={product.bonus_info.bonus_image}
                                      className="w-[60px] h-[60px] md:w-[70px] md:h-[70px] object-contain rounded-md border-2"
                                    />
                                    <div className="w-full">
                                      <p className="w-full truncate overflow-hidden">
                                        <span className="font-bold">
                                          Gratis
                                        </span>{" "}
                                        {product.bonus_info.bonus_name}
                                      </p>
                                      <p>{product.bonus_info.bonus_qty}</p>
                                    </div>
                                  </div>
                                ) : null} */}
                              </div>
                            );
                          })}

                        {SPECIAL_LABEL.map((label) => (
                          <>
                            {dataCheckout.items.filter(
                              (product) => product.label === label.label_name,
                            ).length > 0 ? (
                              <>
                                <hr className="my-3" />
                                <p className="text-[16px] mb-4">
                                  {label.label_name}
                                </p>
                              </>
                            ) : null}
                            {dataCheckout.items
                              .filter(
                                (product) => product.label === label.label_name,
                              )
                              .map((product, i) => {
                                return (
                                  <div>
                                    <div>
                                      <div
                                        className={`flex items-stretch gap-4 ${
                                          i === 0 ? "" : "mt-4"
                                        }`}
                                      >
                                        <img
                                          src={
                                            product.image ? product.image : ""
                                          }
                                          className="w-[100px] h-[100px] object-contain rounded-md border-2"
                                        />
                                        <div className="w-full">
                                          <p
                                            className={`py-1 px-3 mb-2 rounded-full w-fit ${
                                              product.label === "Alat Kesehatan"
                                                ? "bg-[#F9EBFE] text-[#AA31F6]"
                                                : product.label ===
                                                    "Obat Obat Tertentu (OOT)"
                                                  ? "bg-[#FFE7E7] text-[#C62828]"
                                                  : product.label ===
                                                      "Obat Prekursor"
                                                    ? "bg-[#FFE4E4] text-[#FF0000]"
                                                    : product.label ===
                                                        "Obat Psikotropika"
                                                      ? "bg-[#FEEBF7] text-[#F6317D]"
                                                      : "bg-[#EBF5FE] text-[#3194F6]"
                                            }`}
                                          >
                                            {product.label}
                                          </p>
                                          <p className="text-[16px] font-semibold">
                                            {product.name}
                                          </p>
                                          <div className="hidden md:flex gap-2 items-center">
                                            {product.discount ? (
                                              <p>
                                                <s>
                                                  {toIDR(product.unit_price)}
                                                </s>
                                              </p>
                                            ) : null}
                                            {product.discount ? (
                                              <p className="bg-red-100 text-red-500 p-1 rounded-lg">
                                                {formatPercent(product.discount.percent)}
                                              </p>
                                            ) : null}
                                            <p>
                                              {toIDR(
                                                product.discount
                                                  ? (product.unit_price *
                                                      (100 -
                                                        product.discount
                                                          .percent)) /
                                                      100
                                                  : product.unit_price,
                                              )}{" "}
                                              x {product.qty}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="hidden md:flex items-end justify-end">
                                          <p className="mb-2 text-right">
                                            {toIDR(
                                              product.qty *
                                                (product.discount
                                                  ? (product.unit_price *
                                                      (100 -
                                                        product.discount
                                                          .percent)) /
                                                    100
                                                  : product.unit_price),
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="mt-2 md:mt-0 md:hidden flex items-end justify-between">
                                        <div>
                                          <div className="flex gap-2 items-center">
                                            {product.discount ? (
                                              <p>
                                                <s>
                                                  {toIDR(product.unit_price)}
                                                </s>
                                              </p>
                                            ) : null}
                                            {product.discount ? (
                                              <p className="bg-red-100 text-red-500 p-1 rounded-lg">
                                                {formatPercent(product.discount.percent)}
                                              </p>
                                            ) : null}
                                          </div>
                                          <p className="font-semibold">
                                            {toIDR(
                                              product.discount
                                                ? (product.unit_price *
                                                    (100 -
                                                      product.discount
                                                        .percent)) /
                                                    100
                                                : product.unit_price,
                                            )}{" "}
                                            x {product.qty}
                                          </p>
                                        </div>
                                        <div className="text-right font-semibold">
                                          {toIDR(
                                            product.qty *
                                              (product.discount
                                                ? (product.unit_price *
                                                    (100 -
                                                      product.discount
                                                        .percent)) /
                                                  100
                                                : product.unit_price),
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    {/* {product.bonus_info &&
                                    product.bonus_info.bonus_name !== "" &&
                                    product.bonus_info.bonus_qty > 0 ? (
                                      <div className="my-4 pl-20 md:pl-28 flex w-full gap-4 items-center overflow-hidden truncate">
                                        <img
                                          src={product.bonus_info.bonus_image}
                                          className="w-[60px] h-[60px] md:w-[70px] md:h-[70px] object-contain rounded-md border-2"
                                        />
                                        <div className="w-full">
                                          <p className="w-full truncate overflow-hidden">
                                            <span className="font-bold">
                                              Gratis
                                            </span>{" "}
                                            {product.bonus_info.bonus_name}
                                          </p>
                                          <p>{product.bonus_info.bonus_qty}</p>
                                        </div>
                                      </div>
                                    ) : null} */}
                                  </div>
                                );
                              })}
                          </>
                        ))}

                        {/* <hr className="my-3" />
                        <p className="text-[16px] mb-4">Metode Pengiriman</p>
                        <RadioGroup value={0}>
                          <FormControlLabel
                            value={0}
                            control={<Radio />}
                            label={"Same Day"}
                            sx={{
                              width: "45%",
                              display: "flex",
                            }}
                          />
                        </RadioGroup> */}
                        {/* {dataShipping && !isFetchingShipping ? (
                          <RadioGroup
                            value={shipping}
                            onChange={(e) => {
                              handleSelectShipping(e.target.value);
                            }}
                            row
                          >
                            {dataShipping.rates?.map((item) => (
                              <FormControlLabel
                                value={item.provider}
                                control={<Radio />}
                                label={item.service_name}
                                sx={{
                                  width: "45%",
                                  display: "flex",
                                }}
                              />
                            ))}
                          </RadioGroup>
                        ) : null} */}

                        {/* {shippingMethodInsurance ? (
                          <div className="p-3 border-2 border-blue-500 rounded-md flex items-center justify-between gap-4 bg-blue-100">
                            <div>
                              <p className="font-bold">Asuransi Perjalanan</p>
                              <p>
                                Tambahkan asuransi perjalanan{" "}
                                {toIDR(
                                  shippingMethodInsurance
                                    ? shippingMethodInsurance.rate
                                    : 0,
                                )}
                              </p>
                            </div>
                            <Switch
                              checked={useInsurance}
                              onChange={(_, checked) =>
                                setUseInsurance(checked)
                              }
                            />
                          </div>
                        ) : null} */}

                        <TextField
                          fullWidth
                          sx={{ marginTop: 2 }}
                          placeholder="Tulis catatan"
                          value={noteArr[i]}
                          onChange={(e) => {
                            if (e.target.value.length <= 100)
                              setNoteArr([
                                ...noteArr.slice(0, i),
                                e.target.value,
                                ...noteArr.slice(i + 1),
                              ]);
                          }}
                        />
                        <div className="text-right w-full">
                          <small>{noteArr[i]?.length}/100</small>
                        </div>
                      </div>
                    );
                  })
                ) : isLoadingCheckout ? (
                  <CircularProgress size={10} />
                ) : (
                  <p className="text-red-500">
                    Terjadi kesalahan dalam mengambil data checkout
                  </p>
                )}
              </div>
              <div className="w-full lg:basis-1/2">
                <div className="bg-white rounded-lg p-4 h-fit mb-4">
                  <p className="text-[20px] mb-2 font-bold">
                    Metode Pembayaran
                  </p>
                  {selectedPayment ? (
                    <RadioGroup
                      value={selectedPayment}
                      sx={{ marginBottom: 1 }}
                    >
                      <FormControlLabel
                        value={selectedPayment}
                        sx={{ width: "100%" }}
                        control={<Radio />}
                        label={`${paymentMethod ? (paymentMethod.bank ? paymentMethod?.bank : paymentMethod.name) : "Pilih metode pembayaran"} ${
                          creditDetail
                            ? `(${getInstallmentString()})`
                            : selectedPayment === "0" && paymentMethod?.tempo_days
                              ? `(Tempo ${paymentMethod.tempo_days} hari)`
                              : ""
                        }`}
                      />
                    </RadioGroup>
                  ) : (
                    <p className="mb-2 text-gray-400">
                      Pilih metode pembayaran
                    </p>
                  )}
                  <button
                    type="button"
                    className="text-[#6F955B] border-2 border-[#6F955B] bg-[#F1FAF0] hover:bg-gray-300 rounded-md w-full p-2 text-[14px] disabled:bg-gray-300"
                    disabled={
                      isLoadingCheckout ||
                      (dataCheckout && dataCheckout.summary.subtotal === 0)
                    }
                    onClick={() => setOpenPayment(true)}
                  >
                    Ubah
                  </button>
                </div>
                <div className="bg-white rounded-lg p-4 h-fit mb-4">
                  <p className="text-[20px] mb-2 font-bold">Detail Harga</p>
                  <div className="flex items-center justify-between mb-2">
                    <p>
                      Total Harga (
                      {dataCheckout && dataCheckout.items
                        ? dataCheckout.items.length
                        : 0}{" "}
                      produk)
                    </p>
                    <p>
                      {toIDR(dataCheckout ? dataCheckout.summary.subtotal : 0)}
                    </p>
                  </div>
                  <div className="flex items-center justify-between mb-2">
                    <p>Biaya Pengiriman</p>
                    <p>{toIDR(getShippingFee())}</p>
                  </div>
                  <div className="flex items-center justify-between mb-2">
                    <p>Pajak (PPN 11%)</p>
                    <p>
                      {toIDR(
                        dataCheckout ? dataCheckout.summary.ppn_amount : 0,
                      )}
                    </p>
                  </div>
                  <div className="flex items-center justify-between mb-2">
                    <p>Biaya Admin</p>
                    {hasPlan() && isFetchingPlan ? (
                      <CircularProgress size={10} />
                    ) : (
                      <p>
                        {toIDR(
                          paymentMethod &&
                            !(selectedPayment && selectedPayment === "008")
                            ? typeof creditDetail !== "number" &&
                              hasPlan() &&
                              dataPlan &&
                              creditDetail
                              ? dataPlan[creditDetail.index].total_summary
                                  .total_fee_after_ppn_int
                              : selectedPayment === "0"
                                ? 0
                                : Number(paymentMethod.bank_fee)
                            : 0,
                        )}
                      </p>
                    )}
                  </div>
                  {usePoint ? (
                    <div className="flex items-center justify-between mb-2">
                      <p>Poin Loyalty</p>
                      <p>
                        -
                        {toIDR(
                          dataCheckout ? dataCheckout.loyalty_point_balance : 0,
                        )}
                      </p>
                    </div>
                  ) : null}
                  {selectedVoucher ? (
                    <div className="flex items-center justify-between mb-2">
                      <p>Promo</p>
                      <p>-{toIDR(getVoucherValue())}</p>
                    </div>
                  ) : null}
                  <hr className="mb-2" />
                  <div className="flex items-center justify-between mb-2">
                    <div
                      className={`flex gap-2 items-center ${
                        isLoadingCheckout ||
                        dataCheckout?.loyalty_point_balance === 0
                          ? "text-gray-300"
                          : ""
                      }`}
                    >
                      <FaCoins className="text-[#BEB53C] text-[20px]" />
                      <p>
                        Tukarkan{" "}
                        {dataCheckout ? dataCheckout.loyalty_point_balance : ""}{" "}
                        poin
                      </p>
                    </div>
                    <Switch
                      disabled={
                        isLoadingCheckout ||
                        dataCheckout?.loyalty_point_balance === 0
                      }
                      checked={usePoint}
                      onChange={(_, checked) => setUsePoint(checked)}
                    />
                  </div>
                  <button
                    className="w-full border-2 border-[#BEB53C] rounded-md text-[#BEB53C] bg-[#FFFEEE] flex items-center justify-between mb-2 py-3 px-2 hover:bg-gray-100 disabled:bg-gray-300"
                    onClick={() => setOpenVoucher(true)}
                    disabled={isLoadingCheckout}
                  >
                    <div className="flex gap-2 items-center">
                      <IoTicketOutline className="text-[#BEB53C] text-[20px]" />
                      <p>
                        {selectedVoucher
                          ? selectedVoucher.voucher_code
                          : "Pilih kode promo"}
                      </p>
                    </div>
                    <FaChevronRight className="text-[#BEB53C] text-[20px]" />
                  </button>
                  <div className="flex items-center justify-between mb-2 text-[16px]">
                    <p>Total</p>
                    <p className="text-red-500 font-semibold">
                      {toIDR(dataCheckout ? getGrandTotal() : 0)}
                    </p>
                  </div>
                </div>
                <p className="text-red-500 mb-4">
                  {(
                    dataCheckout
                      ? dataCheckout.summary.subtotal < 250000
                      : false
                  )
                    ? "Minimal belanja Rp250.000 untuk dapat melanjutkan pembelian"
                    : ""}
                </p>
                <button
                  type="button"
                  className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-full p-2.5 text-[14px] disabled:bg-gray-300 lg:mb-2"
                  disabled={
                    isLoadingCheckout ||
                    !paymentMethod ||
                    // shippingArr.length === 0 ||
                    (dataCheckout
                      ? dataCheckout.summary.subtotal < 250000
                      : true)
                    // || !shippingMethod
                  }
                  onClick={() => {
                    if (dataCheckout.is_block) setOpenModalOverdue(true);
                    // else setOtpPage(true);
                    else {
                      mutateSubmitCheckout({
                        payment_type: selectedPayment === "0" ? "tempo" : "cbd",
                        // tempo_days tidak dikirim lagi: lama tempo ditetapkan
                        // admin per apotek, dan field-nya sudah dihapus dari
                        // kontrak checkout.
                        payment_channel_id: paymentMethod
                          ? paymentMethod.id
                          : 0,
                        cc_tenor:
                          typeof creditDetail === "number" || !creditDetail
                            ? 0
                            : creditDetail.installment_details.month,
                        voucher_code: selectedVoucher
                          ? selectedVoucher.voucher_code
                          : "",
                        notes: noteArr[0],
                        is_use_point: usePoint,
                        // shipping: {
                        //   provider: shippingMethod.provider,
                        //   service_code: shippingMethod.service_code,
                        //   insurance_enabled: useInsurance,
                        // },
                      });
                    }
                  }}
                >
                  Bayar Sekarang
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <ModalPaymentOption
        open={openPayment}
        setOpen={setOpenPayment}
        selected={selectedPayment}
        setSelected={setSelectedPayment}
        dataPaymentMethod={dataPaymentMethod}
        isFetchingPaymentMethod={isFetchingPaymentMethod}
        grandTotal={
          dataCheckout ? dataCheckout.summary.grand_total_estimate : 0
        }
        subTotal={dataCheckout ? dataCheckout.summary.subtotal : 0}
        creditDetail={creditDetail}
        setCreditDetail={setCreditDetail}
        foundPayment={paymentMethod}
      />

      <ModalVoucher
        open={openVoucher}
        setOpen={setOpenVoucher}
        selected={selectedVoucher}
        setSelected={setSelectedVoucher}
        total={
          // selectedVoucher && dataCheckout
          //   ? selectedVoucher.voucher_type === 1
          //     ? dataCheckout.result.shipping
          //     : selectedVoucher.voucher_type === 2
          //       ? dataCheckout.summary.subtotal
          //       : 0
          //   : 0
          0
        }
      />

      <ModalOverduePayment
        open={openModalOverdue}
        setOpen={setOpenModalOverdue}
      />

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default CheckoutPurchase;
